export const FEATURED_CALLOUT_COLORS = {
  THUNDERDOME_TO_CALYPSO: ['fill-accent-purple-default', 'fill-accent-blue-default'],
  CALYPSO_TO_OZ: ['fill-accent-blue-default', 'fill-accent-green-default'],
  SORBET_TO_MARIGOLD: ['fill-accent-light-orange-default', 'fill-accent-yellow-default'],
  NORMAN_TO_CANDY_APPLE: ['fill-accent-magenta-default', 'fill-accent-red-default'],
  CANDY_APPLE_TO_LORAX: ['fill-accent-red-default', 'fill-accent-orange-default'],
  LORAX_TO_SORBET: ['fill-accent-orange-default', 'fill-accent-light-orange-default']
};
export let FEATURED_CALLOUT_LAYOUT_TYPES;
(function (FEATURED_CALLOUT_LAYOUT_TYPES) {
  FEATURED_CALLOUT_LAYOUT_TYPES["FULL_WIDTH"] = "FULL_WIDTH";
  FEATURED_CALLOUT_LAYOUT_TYPES["MULTI"] = "MULTI";
})(FEATURED_CALLOUT_LAYOUT_TYPES || (FEATURED_CALLOUT_LAYOUT_TYPES = {}));